// extracted by mini-css-extract-plugin
export default {"header":"mobile_header_header__8sDUe","shopName":"mobile_header_shopName__539gO","buttonOpenSearch":"mobile_header_buttonOpenSearch__QlS8b"};